/**
 * OutreachTemplatesSection component - Main section for displaying outreach templates
 */

import React from 'react';
import { useDriveFolders } from '../../hooks/useDriveFolders';
import FolderGrid from './FolderGrid';
import LoadingState from './LoadingState';
import ErrorState from './ErrorState';
import EmptyState from './EmptyState';
import '../../styles/outreach-templates.css';

const OutreachTemplatesSection: React.FC = () => {
  const { folders, loading, error, refetch } = useDriveFolders();

  return (
    <section className="outreach-templates-section" data-testid="recruiting-outreach-templates">
      <h2 className="outreach-templates-title">Outreach templates</h2>

      {loading && <LoadingState />}

      {error && !loading && (
        <ErrorState message={error} onRetry={refetch} />
      )}

      {!loading && !error && folders.length === 0 && <EmptyState />}

      {!loading && !error && folders.length > 0 && (
        <FolderGrid folders={folders} />
      )}
    </section>
  );
};

export default OutreachTemplatesSection;

